export default __webpack_public_path__ + "assets/pdf/FT_VG39.ed00567d.pdf";